import { Route } from "lucide-react";
import { fmtUTC } from "@/lib/maritime";

// Small on-map caption explaining the currently displayed vessel track.
export const TrackLegend = ({ info }) => {
  if (!info || !info.count) return null;
  return (
    <div
      data-testid="track-legend"
      className="absolute bottom-4 left-4 z-20 flex items-center gap-3 rounded-lg bg-slate-900/90 backdrop-blur-md border border-slate-800/90 px-3 py-2 shadow-xl"
    >
      <div className="flex items-center gap-2">
        <span className="h-0.5 w-6 rounded-full" style={{ backgroundColor: "#1D4ED8" }} />
        <Route className="h-3.5 w-3.5 text-[#1D4ED8]" />
      </div>
      <div className="leading-tight">
        <div className="font-mono text-[11px] text-slate-200">
          Track · {info.windowKey} · {info.count} pts
        </div>
        <div className="font-mono text-[10px] text-slate-500">
          {info.from ? fmtUTC(new Date(info.from).getTime()) : ""} → {info.to ? fmtUTC(new Date(info.to).getTime()) : ""}
        </div>
      </div>
    </div>
  );
};

export default TrackLegend;
